import React from "react";

export default function Footer() {
  return (
    <div className="footer-custom p-2">
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="mb-0 text-center text-black ">
                <div className="footerText">

              {" "}
              &copy; 2023, Web App Made with{" "}
              <span className="text-white">❤</span> by{" "}
              <a
                href="https://www.linkedin.com/in/usman-mirza/"
                target="_blank"
                className="text-white text-decoration-none fw-small "
                >
                Usman Ali
              </a>
                  </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
